// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2ZadA","content":"GlobalSearch_content__1R0an"};